import "./index.scss";

const Featured = () => {
  return (
    <div className="featured-section">
      <div className="title extra-space-up">Featured</div>
      <div className="video-section">
        <iframe
          className="video-frame"
          width="800"
          height="500"
          src="https://www.youtube.com/embed/E8I4wFeq2h4"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
      </div>
    </div>
  );
};
export default Featured;
